import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddressBook = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11 9.00001H27C27.5304 9.00001 28 9.00001 29 9C29 9.49999 29 10.4696 29 11V29C29 29.5304 29 30 29 31C28 31 27.5304 31 27 31H11V9.00001Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32 13V17",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.2471 20.1333C21.6639 20.1333 22.8124 18.9842 22.8124 17.5667C22.8124 16.1491 21.6639 15 20.2471 15C18.8303 15 17.6818 16.1491 17.6818 17.5667C17.6818 18.9842 18.8303 20.1333 20.2471 20.1333Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.7273 24.185C18.7245 22.1866 21.9678 22.1866 23.9742 24.185",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgAddressBook);
export default ForwardRef;
